<!-- Page Header -->
<app-page-header title="Accounting Report" subtitle="Financial overview and reservation details">
    <div actions class="flex gap-3">
        <p-button
            label="Filters"
            icon="filter_alt"
            [outlined]="true"
            styleClass="p-button-secondary"
            (click)="openFilterDialog()"
        ></p-button>
        <p-button label="Export Report" icon="download" styleClass="p-button-primary" (click)="exportReport()"></p-button>
    </div>
</app-page-header>
<!-- Filter Dialog -->
<p-dialog
    header="Filters"
    [(visible)]="filterDialogVisible"
    [style]="{ width: '520px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    styleClass="filter-dialog"
>
    <div class="flex flex-col gap-4 p-2" style="max-height: 70vh; overflow-y: auto">
        <!-- Date Range Section -->
        <div class="border border-gray-100 rounded-lg p-4 bg-gray-50/50">
            <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span class="material-icons-outlined text-blue-500">calendar_month</span>
                Reservation Dates
            </h4>
            <div class="grid grid-cols-2 gap-3">
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">From</label>
                    <p-datepicker
                        [showClear]="true"
                        [(ngModel)]="filters.reservationFrom"
                        [showIcon]="true"
                        placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'"
                    ></p-datepicker>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">To</label>
                    <p-datepicker
                        [showClear]="true"
                        [(ngModel)]="filters.reservationTo"
                        [showIcon]="true"
                        placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'"
                    ></p-datepicker>
                </div>
            </div>
        </div>

        <!-- Flight Date Section -->
        <div class="border border-gray-100 rounded-lg p-4 bg-gray-50/50">
            <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span class="material-icons-outlined text-green-500">send</span>
                Flight Dates
            </h4>
            <div class="grid grid-cols-2 gap-3">
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">From</label>
                    <p-datepicker
                        [showClear]="true"
                        [(ngModel)]="filters.flightDateFrom"
                        [showIcon]="true"
                        placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'"
                    ></p-datepicker>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">To</label>
                    <p-datepicker
                        [showClear]="true"
                        [(ngModel)]="filters.flightDateTo"
                        [showIcon]="true"
                        placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy"
                        [appendTo]="'body'"
                    ></p-datepicker>
                </div>
            </div>
        </div>

        <!-- Location Section -->
        <div class="border border-gray-100 rounded-lg p-4 bg-gray-50/50">
            <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span class="material-icons-outlined text-red-500">location_on</span>
                Location
            </h4>
            <div class="grid grid-cols-2 gap-3">
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">From Port</label>
                    <p-select
                        [disabled]="portLoading || !ports.length"
                        [loading]="portLoading"
                        [(ngModel)]="filters.flightFromPort"
                        [options]="ports"
                        optionLabel="code"
                        optionValue="code"
                        placeholder="Select Port"
                        [appendTo]="'body'"
                        [filter]="true"
                        filterBy="code,explanation,city,country"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="34"
                        [showClear]="true"
                        [dropdownIcon]="'expand_more'"
                        [loadingIcon]="'sync'"
                    >
                    </p-select>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">To Port</label>
                    <p-select
                        [disabled]="portLoading || !ports.length"
                        [loading]="portLoading"
                        [(ngModel)]="filters.flightToPort"
                        [options]="ports"
                        optionLabel="code"
                        optionValue="code"
                        placeholder="Select Port"
                        [appendTo]="'body'"
                        [filter]="true"
                        filterBy="code,explanation,city,country"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="34"
                        [showClear]="true"
                        [dropdownIcon]="'expand_more'"
                        [loadingIcon]="'sync'"
                    >
                    </p-select>
                </div>
            </div>
        </div>

        <!-- Other Filters -->
        <div class="border border-gray-100 rounded-lg p-4 bg-gray-50/50">
            <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span class="material-icons-outlined text-purple-500">settings</span>
                Other Filters
            </h4>
            <div class="grid grid-cols-3 gap-3">
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">Reservation Type</label>
                    <p-select
                        [showClear]="true"
                        [(ngModel)]="filters.reservationType"
                        [options]="reservationTypes"
                        optionLabel="name"
                        placeholder="Select"
                        [appendTo]="'body'"
                    ></p-select>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">Provider</label>
                    <p-select
                        [(ngModel)]="filters.provider"
                        [options]="providers"
                        optionLabel="explanation"
                        optionValue="code"
                        placeholder="Select"
                        [appendTo]="'body'"
                        [filter]="true"
                        filterBy="explanation,code"
                        [showClear]="true"
                    >
                    </p-select>
                </div>
                <div class="flex flex-col gap-1.5">
                    <label class="text-xs font-medium text-gray-600">Airline</label>
                    <p-select
                        [(ngModel)]="filters.airline"
                        [options]="airlines"
                        optionLabel="name"
                        optionValue="code"
                        placeholder="Select"
                        [appendTo]="'body'"
                        [filter]="true"
                        filterBy="name,code"
                        [showClear]="true"
                    >
                    </p-select>
                </div>
            </div>
        </div>

        @if (errorMsg.length > 0) {
            <div class="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
                <span class="material-icons-outlined text-red-500">error</span>
                <small class="text-sm text-red-600">{{ errorMsg }}</small>
            </div>
        }
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-between w-full pt-3 border-t border-gray-100">
            <p-button
                label="Clear All"
                icon="delete"
                (click)="clearFilters()"
                [outlined]="true"
                styleClass="p-button-text p-button-secondary"
            ></p-button>
            <div class="flex gap-2">
                <p-button label="Cancel" (click)="filterDialogVisible = false" [outlined]="true" styleClass="p-button-secondary"></p-button>
                <p-button label="Apply Filters" icon="check" (click)="applyFilters()" styleClass="p-button-primary"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Trip Count Cards -->
<div class="grid grid-cols-2 gap-4 mb-6">
    @for (item of data; track $index) {
        <app-card icon="sync" title="Roundtrip" iconGradient="from-blue-500 to-blue-600">
            <div class="flex items-baseline gap-1">
                <span class="text-3xl font-bold text-gray-900">{{ item.roundTrip }}</span>
                <span class="text-sm text-gray-500">reservations</span>
            </div>
        </app-card>
        <app-card icon="arrow_forward" title="Oneway" iconGradient="from-green-500 to-green-600">
            <div class="flex items-baseline gap-1">
                <span class="text-3xl font-bold text-gray-900">{{ item.oneWay }}</span>
                <span class="text-sm text-gray-500">reservations</span>
            </div>
        </app-card>
    }
</div>

<!-- Summary Table -->
<app-card icon="trending_up" title="Financial Summary" iconGradient="from-indigo-500 to-purple-600" class="mb-6">
    <p-table [value]="rows" [loading]="loading" styleClass="modern-table" [scrollable]="true" scrollHeight="auto">
        <ng-template pTemplate="header">
            <tr>
                <th class="w-32 bg-gray-50/80 text-gray-700 font-semibold text-xs uppercase tracking-wider">Metric</th>
                @for (group of summaryData; track $index; let i = $index) {
                    <th class="text-center text-xs uppercase tracking-wider">
                        {{ group.categoryName }}
                    </th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
            <tr class="hover:bg-gray-50/60 transition-colors">
                <td class="font-medium text-gray-700 bg-gray-50/50">{{ row.label }}</td>
                @for (group of summaryData; track $index; let i = $index) {
                    <td class="text-center" [class.bg-gray-50/30]="i % 2 !== 0">
                        @if (row.key === 'revenue') {
                            <span class="inline-flex items-center gap-1 text-green-600 font-medium">
                                <span class="material-icons-outlined text-xs">north_east</span>
                                {{ group.metrics.revenue.amount }} {{ group.metrics.revenue.currency }}
                            </span>
                        } @else if (row.key === 'cost') {
                            <span class="inline-flex items-center gap-1 text-red-600 font-medium">
                                <span class="material-icons-outlined text-xs">south_east</span>
                                {{ group.metrics.cost.amount }} {{ group.metrics.cost.currency }}
                            </span>
                        } @else if (row.key === 'profit') {
                            <span
                                class="inline-flex items-center gap-1"
                                [class.text-green-600]="group.metrics.profit.amount >= 0"
                                [class.text-red-600]="group.metrics.profit.amount < 0"
                            >
                                <span class="material-icons-outlined" [class.text-xs]="true">{{
                                    group.metrics.profit.amount >= 0 ? 'arrow_upward' : 'arrow_downward'
                                }}</span>
                                {{ group.metrics.profit.amount }} {{ group.metrics.profit.currency }}
                            </span>
                        } @else if (row.key === 'margin') {
                            <span
                                class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"
                                [class.bg-green-100]="group.metrics.marginPercentage >= 0"
                                [class.text-green-700]="group.metrics.marginPercentage >= 0"
                                [class.bg-red-100]="group.metrics.marginPercentage < 0"
                                [class.text-red-700]="group.metrics.marginPercentage < 0"
                            >
                                {{ group.metrics.marginPercentage }}%
                            </span>
                        }
                    </td>
                }
            </tr>
        </ng-template>
    </p-table>
</app-card>
<!-- Monthly Data -->
<app-card icon="calendar_month" title="Monthly Breakdown" iconGradient="from-teal-500 to-cyan-600" class="mb-6">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <p-tabs [(value)]="selectedTabIndex" (valueChange)="onTabChange($event)" styleClass="year-tabs">
                <p-tablist>
                    @for (tab of tabs; track $index) {
                        <p-tab [value]="tab.value">{{ tab.title }}</p-tab>
                    }
                </p-tablist>
            </p-tabs>
        </div>
    </ng-template>

    <p-table [value]="rows" styleClass="modern-table monthly-table" [scrollable]="true" scrollHeight="auto">
        <ng-template pTemplate="header">
            <tr>
                <th class="w-32 bg-gray-50/80 text-gray-700 font-semibold text-xs uppercase tracking-wider sticky left-0 z-10">Metric</th>
                @for (monthly of totalByMonth.monthly; track $index; let i = $index) {
                    <th class="text-center text-xs uppercase tracking-wider min-w-28" [class.bg-gray-50/50]="i % 2 !== 0">
                        {{ cols[monthly.month].label }}
                    </th>
                }
                <th class="text-center text-xs uppercase tracking-wider bg-blue-50/80 text-blue-700 font-bold sticky right-0 z-10 min-w-28">
                    Total
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
            <tr class="hover:bg-gray-50/60 transition-colors">
                <td class="font-medium text-gray-700 bg-gray-50/50 sticky left-0 z-10">{{ row.label }}</td>
                @for (group of totalByMonth.monthly; track $index; let i = $index) {
                    <td class="text-center" [class.bg-gray-50/30]="i % 2 !== 0">
                        @if (row.key === 'revenue') {
                            <span class="text-green-600 font-medium"
                                >{{ group.metrics.revenue.amount }} {{ group.metrics.revenue.currency }}</span
                            >
                        } @else if (row.key === 'cost') {
                            <span class="text-red-600 font-medium">{{ group.metrics.cost.amount }} {{ group.metrics.cost.currency }}</span>
                        } @else if (row.key === 'profit') {
                            <span
                                [class.text-green-600]="group.metrics.profit.amount >= 0"
                                [class.text-red-600]="group.metrics.profit.amount < 0"
                                class="font-medium"
                                >{{ group.metrics.profit.amount }} {{ group.metrics.profit.currency }}</span
                            >
                        } @else if (row.key === 'margin') {
                            <span
                                class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"
                                [class.bg-green-100]="group.metrics.marginPercentage >= 0"
                                [class.text-green-700]="group.metrics.marginPercentage >= 0"
                                [class.bg-red-100]="group.metrics.marginPercentage < 0"
                                [class.text-red-700]="group.metrics.marginPercentage < 0"
                                >{{ group.metrics.marginPercentage }}%</span
                            >
                        }
                    </td>
                }
                <td class="text-center bg-blue-50/50 sticky right-0 z-10">
                    @if (row.key === 'revenue') {
                        <span class="text-green-600 font-bold"
                            >{{ totalByMonth.total.revenue.amount }} {{ totalByMonth.total.revenue.currency }}</span
                        >
                    } @else if (row.key === 'cost') {
                        <span class="text-red-600 font-bold"
                            >{{ totalByMonth.total.cost.amount }} {{ totalByMonth.total.cost.currency }}</span
                        >
                    } @else if (row.key === 'profit') {
                        <span
                            [class.text-green-600]="totalByMonth.total.profit.amount >= 0"
                            [class.text-red-600]="totalByMonth.total.profit.amount < 0"
                            class="font-bold"
                            >{{ totalByMonth.total.profit.amount }} {{ totalByMonth.total.profit.currency }}</span
                        >
                    } @else if (row.key === 'margin') {
                        <span
                            class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold"
                            [class.bg-green-100]="totalByMonth.total.marginPercentage >= 0"
                            [class.text-green-700]="totalByMonth.total.marginPercentage >= 0"
                            [class.bg-red-100]="totalByMonth.total.marginPercentage < 0"
                            [class.text-red-700]="totalByMonth.total.marginPercentage < 0"
                            >{{ totalByMonth.total.marginPercentage }}%</span
                        >
                    }
                </td>
            </tr>
        </ng-template>
    </p-table>
</app-card>
<!-- Reservations Table -->
<app-card icon="confirmation_number" title="Reservations" iconGradient="from-orange-500 to-red-500">
    <ng-template #headerTemplate>
        <span class="ml-3 text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full">{{ totalRecords }} records</span>
    </ng-template>

    <p-table
        [dataKey]="'__key'"
        rowExpansionMode="single"
        (onRowExpand)="onRowExpand($event)"
        [loading]="loading"
        [value]="reservations"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [first]="first"
        [paginator]="true"
        [rows]="tableState.size"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 30, 50]"
        [globalFilterFields]="[
            'reservationType',
            'flightType',
            'agent',
            'flightDate',
            'pnr',
            'airlinePnr',
            'airline',
            'reservationDate',
            'from.code',
            'to.code',
            'from.country',
            'to.country',
            'totalTax.amount',
            'total.revenue.amount'
        ]"
        [responsiveLayout]="'scroll'"
        [paginatorPosition]="'bottom'"
        [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
        [showCurrentPageReport]="true"
        [showFirstLastIcon]="true"
        [showJumpToPageDropdown]="true"
        [showPageLinks]="true"
        styleClass="modern-table reservations-table"
    >
        <ng-template pTemplate="header">
            <tr>
                <th class="w-10"></th>
                @for (col of reservationCols; track $index) {
                    <th class="text-xs uppercase tracking-wider font-semibold text-gray-700">{{ col.label }}</th>
                }
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-expanded="expanded">
            <tr class="hover:bg-gray-50/60 transition-colors group">
                <td>
                    <p-button
                        type="button"
                        pRipple
                        [pRowToggler]="rowData"
                        [text]="true"
                        [rounded]="true"
                        [icon]="expanded ? 'expand_more' : 'chevron_right'"
                        styleClass="w-8 h-8 p-0"
                    ></p-button>
                </td>
                <td>
                    <span
                        class="inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium"
                        [class.bg-blue-100]="rowData.reservationType === 'Roundtrip'"
                        [class.text-blue-700]="rowData.reservationType === 'Roundtrip'"
                        [class.bg-green-100]="rowData.reservationType === 'Oneway'"
                        [class.text-green-700]="rowData.reservationType === 'Oneway'"
                    >
                        <span class="material-icons-outlined text-sm">{{
                            rowData.reservationType === 'Roundtrip' ? 'sync' : 'arrow_forward'
                        }}</span>
                        {{ rowData.reservationType }}
                    </span>
                </td>
                <td class="text-gray-600">{{ rowData.flightType }}</td>
                <td class="font-medium text-gray-900">{{ rowData.pnr }}</td>
                <td class="text-gray-600">{{ rowData.airlinePnr }}</td>
                <td class="text-gray-600">{{ rowData.agent }}</td>
                <td>
                    <span class="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-xs font-medium">
                        <span class="material-icons-outlined text-xs">flight</span>
                        {{ rowData.airline }}
                    </span>
                </td>
                <td class="text-gray-600">{{ rowData.reservationDate }}</td>
                <td class="text-gray-600">{{ rowData.flightDate }}</td>
                <td>
                    <span class="inline-flex items-center gap-1 text-xs">
                        <span class="material-icons-outlined text-gray-400 text-sm">location_on</span>
                        {{ rowData?.from?.code }}
                    </span>
                </td>
                <td>
                    <span class="inline-flex items-center gap-1 text-xs">
                        <span class="material-icons-outlined text-gray-400 text-sm">location_on</span>
                        {{ rowData?.to?.code }}
                    </span>
                </td>
                <td class="text-gray-600 text-xs">{{ rowData.from?.country }}</td>
                <td class="text-gray-600 text-xs">{{ rowData?.to?.country }}</td>
                <td class="text-right text-gray-600">{{ rowData?.totalTax?.amount }} {{ rowData?.totalTax?.currency }}</td>
                <td class="text-right font-semibold text-gray-900">
                    {{ rowData?.total.revenue?.amount }} {{ rowData?.total.revenue?.currency }}
                </td>
            </tr>
        </ng-template>

        <ng-template #expandedrow let-reservation>
            <tr>
                <td [attr.colspan]="15" class="p-0">
                    <div class="bg-gradient-to-r from-gray-50 to-white p-5 border-t border-b border-gray-100">
                        <!-- Departure Breakdown -->
                        @if (getDepartureBreakdown(reservation)) {
                            <div class="mb-5">
                                <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                    <span class="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                                        <span class="material-icons-outlined text-blue-600 text-xs">arrow_forward</span>
                                    </span>
                                    Departure Breakdown
                                </h4>
                                <div class="overflow-x-auto rounded-lg border border-gray-200">
                                    <p-table [value]="['Revenue', 'Cost']" styleClass="nested-table">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="w-28 bg-gray-100 text-xs">Type</th>
                                                <th class="text-xs">Flight</th>
                                                @for (
                                                    k of getShoppingCategoryKeys(reservation, 'DEPARTURE');
                                                    track $index;
                                                    let i = $index
                                                ) {
                                                    <th class="text-xs" [class.bg-gray-50]="i % 2 === 0">{{ humanizeKey(k) }}</th>
                                                }
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-row let-i="rowIndex">
                                            <tr>
                                                <td class="font-medium bg-gray-50 text-xs">{{ row }}</td>
                                                <td class="text-center text-xs">
                                                    {{ getFlightValue(reservation, 'DEPARTURE', row.toLowerCase()) }}
                                                </td>
                                                @for (
                                                    category of getShoppingCategoryKeys(reservation, 'DEPARTURE');
                                                    track $index;
                                                    let i = $index
                                                ) {
                                                    <td class="text-center text-xs" [class.bg-gray-50/50]="i % 2 === 0">
                                                        {{
                                                            getShoppingCategoryValue(reservation, 'DEPARTURE', category, row.toLowerCase())
                                                        }}
                                                    </td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        }

                        <!-- Return Breakdown -->
                        @if (getReturnBreakdown(reservation)) {
                            <div class="mb-5">
                                <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                    <span class="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                                        <span class="material-icons-outlined text-green-600 text-xs">sync</span>
                                    </span>
                                    Return Breakdown
                                </h4>
                                <div class="overflow-x-auto rounded-lg border border-gray-200">
                                    <p-table [value]="['Revenue', 'Cost']" styleClass="nested-table">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="w-28 bg-gray-100 text-xs">Type</th>
                                                <th class="text-xs">Flight</th>
                                                @for (k of getShoppingCategoryKeys(reservation, 'RETURN'); track $index; let i = $index) {
                                                    <th class="text-xs" [class.bg-gray-50]="i % 2 === 0">{{ humanizeKey(k) }}</th>
                                                }
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-row let-i="rowIndex">
                                            <tr>
                                                <td class="font-medium bg-gray-50 text-xs">{{ row }}</td>
                                                <td class="text-center text-xs">
                                                    {{ getFlightValue(reservation, 'RETURN', row.toLowerCase()) }}
                                                </td>
                                                @for (
                                                    category of getShoppingCategoryKeys(reservation, 'RETURN');
                                                    track $index;
                                                    let i = $index
                                                ) {
                                                    <td class="text-center text-xs" [class.bg-gray-50/50]="i % 2 === 0">
                                                        {{ getShoppingCategoryValue(reservation, 'RETURN', category, row.toLowerCase()) }}
                                                    </td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        }

                        <!-- Total Summary -->
                        @if (getTotalSummary(reservation)) {
                            <div>
                                <h4 class="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                                    <span class="w-6 h-6 rounded-full bg-purple-100 flex items-center justify-center">
                                        <span class="material-icons-outlined text-purple-600 text-xs">calculate</span>
                                    </span>
                                    Total Summary
                                </h4>
                                <div class="overflow-x-auto rounded-lg border border-gray-200">
                                    <p-table [value]="['Revenue', 'Cost', 'Profit', 'Payment Type']" styleClass="nested-table">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="w-28 bg-gray-100 text-xs">Type</th>
                                                <th class="bg-blue-50/80 text-xs text-blue-700">Ticket</th>
                                                <th class="bg-blue-50/80 text-xs text-blue-700">Other</th>
                                                @for (item of getReservationProductKeys(reservation); track $index; let i = $index) {
                                                    <th class="bg-blue-50/80 text-xs text-blue-700">{{ humanizeKey(item) }}</th>
                                                }
                                                <th class="bg-blue-50/80 text-xs text-blue-700">Commission</th>
                                                <th class="bg-green-50/80 text-xs text-green-700">Total</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-row let-i="rowIndex">
                                            <tr>
                                                <td class="font-medium bg-gray-50 text-xs">{{ row }}</td>
                                                <td class="text-center text-xs">
                                                    {{ getTotalSummaryValue(reservation, 'ticket', row.toLowerCase()) }}
                                                </td>
                                                <td class="text-center text-xs">
                                                    {{ getTotalSummaryValue(reservation, 'other', row.toLowerCase()) }}
                                                </td>
                                                @for (item of getReservationProductKeys(reservation); track $index; let i = $index) {
                                                    <td class="text-center text-xs">
                                                        {{ getReservationProductValue(reservation, item, row.toLowerCase()) }}
                                                    </td>
                                                }
                                                <td class="text-center text-xs">
                                                    {{ getTotalSummaryValue(reservation, 'commission', row.toLowerCase()) }}
                                                </td>
                                                <td class="text-center text-xs font-semibold">
                                                    {{ getTotalSummaryValue(reservation, 'total', row.toLowerCase()) }}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</app-card>
